// store/cabinet/createCabinetSlice.ts

import { StateCreator } from 'zustand';

import { createFunctionalSetter } from '../storeCommons';
import { cabinetInitialState, CabinetState } from './cabinetInitialState';

/**
 * @french
 * Interface des actions liées à la balance.
 */
export interface CabinetActions {
  setCollaborators: (
    updater:
      | CabinetState['collaborators']
      | ((prev: CabinetState['collaborators']) => CabinetState['collaborators']),
  ) => void;

  reset: () => void;
}

/**
 * @french
 * Slice Zustand pour les actions de la balance.
 */
export const createCabinetSlice: StateCreator<
  CabinetState & CabinetActions,
  [],
  [],
  CabinetActions
> = (set, get) => ({
  setCollaborators: createFunctionalSetter(get, set, 'collaborators'),
  reset: () => set(cabinetInitialState),
});
